import { render, staticRenderFns } from "./CmgCheckoutPage.vue?vue&type=template&id=113b4ebe&scoped=true&lang=pug&"
import script from "./cmg-checkout-page.ts?vue&type=script&lang=ts&"
export * from "./cmg-checkout-page.ts?vue&type=script&lang=ts&"
import style0 from "./CmgCheckoutPage.vue?vue&type=style&index=0&id=113b4ebe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113b4ebe",
  null
  
)

export default component.exports